import { invokeApi } from "../../bl_libs/invokeApi";

export const getTrackerAutomationsApi = async ({
  page = 1,
  limit = 100,
  search = "",
  trackerId = "",
  sortBy = "updatedAt",
  sortDir = "desc",
} = {}) => {
  const queryParams = [];
  if (page) queryParams.push(`page=${encodeURIComponent(page)}`);
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
  if (trackerId) queryParams.push(`trackerId=${encodeURIComponent(trackerId)}`);
  if (sortBy) queryParams.push(`sortBy=${encodeURIComponent(sortBy)}`);
  if (sortDir) queryParams.push(`sortDir=${encodeURIComponent(sortDir)}`);

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

  return invokeApi({
    path: `api/tracker_automation${queryString}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  });
};

export const getTrackerAutomationDetailApi = async (id) =>
  invokeApi({
    path: `api/tracker_automation/${encodeURIComponent(id)}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  });

export const addTrackerAutomationApi = async (data) =>
  invokeApi({
    path: `api/tracker_automation`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  });

export const updateTrackerAutomationApi = async (id, data) =>
  invokeApi({
    path: `api/tracker_automation/${encodeURIComponent(id)}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  });

export const deleteTrackerAutomationApi = async (id) =>
  invokeApi({
    path: `api/tracker_automation/${encodeURIComponent(id)}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  });
